import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { breakpoints, SectionThemeProvider } from "@trustpilot/businessapp-patternlibrary";

import { getNavigationWidth } from "../styles";
import { zIndexValues } from "./constants";

export const StyledWrapper = styled.section<any>(({ styles, useSimplifiedLayout }) => ({
  ...styles,
  [`@media (max-width: ${breakpoints.medium}px)`]: {
    width: useSimplifiedLayout ? 0 : `${getNavigationWidth(true)}px`,
  },
  [`@media (min-width: ${breakpoints.medium}px)`]: {
    width: useSimplifiedLayout ? 0 : `${getNavigationWidth(false)}px`,
  },
}));

export const StyledContent = styled.div<any>(({ styles }) => styles);

export const DarkGreenTheme = (
  props: React.PropsWithChildren<{
    className?: string;
  }>,
) => (
  <SectionThemeProvider theme="dark-green" className={props.className}>
    {props.children}
  </SectionThemeProvider>
);

export const StyledLeftNav = styled(DarkGreenTheme)<any>(({ styles }) => styles);

interface StyledTopbarProps {
  withBackground: boolean;
  isCollapsed?: boolean;
}

export const StyledTopbar = styled.nav<StyledTopbarProps>(({ withBackground, isCollapsed = false }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: withBackground ? "var(--trustpilot-brand-green-10)" : null,
  position: "relative",
  zIndex: zIndexValues.z80,
  padding: isCollapsed ? "0" : "0 16px",
  flexShrink: 0,
  [`@media (min-width: ${breakpoints.medium}px)`]: {
    padding: 0,
    boxShadow: "inset 0 -1px 0 rgba(255, 255, 255, .10)",
  },
}));

interface StyledOverlayProps {
  show: boolean;
  zIndex?: number;
}

export const StyledOverlay = styled.div<StyledOverlayProps>(({ show, zIndex = zIndexValues.z70 }) => ({
  display: show ? "block" : "none",
  backgroundColor: "var(--trustpilot-brand-green-10)",
  opacity: 0.5,
  bottom: 0,
  left: 0,
  position: "fixed",
  cursor: "pointer",
  right: 0,
  top: 0,
  zIndex,
  [`@media (min-width: ${breakpoints.small}px)`]: {
    display: "none",
  },
}));

export const StyledFormGroup = styled.div(() => ({
  paddingBottom: "16px",
}));

const screenReaderOnlyCSS = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;

export const ScreenReaderOnlyDiv = styled.div`
  ${screenReaderOnlyCSS}
`;

export const ScreenReaderOnlyH2 = styled.h2`
  ${screenReaderOnlyCSS}
`;
